import { Box, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useTheme } from '@mui/styles';
import moment from 'moment';

const CarRecordSection = ({ time, status, location, lineStyles, arrived = true }) => {
  const theme = useTheme();
  const darkColor = theme.palette.primary[900];
  const greyColor = theme.palette.grey['A200'];
  const secondaryColor = theme.palette.primary['lighter'];

  return (
    <Grid direction="row" overflow="hidden" container columnGap={2}>
      <Grid item xs={3}>
        <Stack direction="row" alignItems="start" justifyContent="flex-end" columnGap={1}>
          <Stack alignItems="flex-end">
            {time && (
              <>
                {' '}
                <Typography variant="body1" color={arrived ? 'initial' : greyColor}>
                  {moment(time).format('HH:mm')}
                </Typography>
                <Typography
                  variant="body2"
                  color={greyColor}
                  // sx={{
                  //   fontSize: '0.6rem'
                  // }}
                >
                  {moment(time).format('DD/MM')}
                </Typography>{' '}
              </>
            )}
          </Stack>
          <Box
            mr="14px"
            sx={{
              borderRadius: '12px',
              boxShadow: ' 2px 3px 6px 0 rgba(0, 0, 0, 0.16)'
            }}
            p="3px"
            display="flex"
          >
            <LocationOnIcon sx={{ fill: arrived ? darkColor : greyColor, fontSize: '14px' }} />
          </Box>
        </Stack>
        <Box borderRight={`1px solid ${greyColor}`} sx={lineStyles} height="100%" mr="23px" />
      </Grid>
      <Grid item xs={8} rowGap={2} mb={1}>
        <Typography variant="h6">{status}</Typography>
        <Box
          p={1}
          sx={{
            bgcolor: arrived ? secondaryColor : '#f0f0f0',
            borderRadius: '8px'
          }}
        >
          <Typography variant="body2" color={arrived ? 'initial' : greyColor}>
            {location}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default CarRecordSection;
